import {
  SET_BUSINESS_ALL_DETAIL,
  SET_BUSINESS_ALL_DETAIL_REQUEST,
  FILTER_BUSINESS_LIST,
  SET_BUSINESS_DETAIL_FROM_LIST_REQUEST,
  SET_BUSINESS_DETAIL_FROM_LIST,
  BUSINESS_PROFILE_SAVE_SUPER,
  BUSINESS_PROFILE_IMAGE_FILE_SUPER,
  HANDLE_REQUEST_CLOSE_BUSINESS_PROFILE,
  TOGGLE_DISABLED_BUSINESS,
  TOGGLE_DISABLED_BUSINESS_PROFILE
} from '../constants/ActionTypes';

export const requestBusinessList = () => ({
  type: SET_BUSINESS_ALL_DETAIL_REQUEST
});

export const requestBusinessListSuccess = payload => ({
  type: SET_BUSINESS_ALL_DETAIL,
  payload
});

export const getFilterBusinessData = payload => ({
  type: FILTER_BUSINESS_LIST,
  payload
});

export const requestBusinessDetail = payload => ({
  type: SET_BUSINESS_DETAIL_FROM_LIST_REQUEST,
  payload
});

export const getBusinessDetailSuccess = payload => ({
  type: SET_BUSINESS_DETAIL_FROM_LIST,
  payload
});

export const businessProfileSaveSuper = payload => ({
  type: BUSINESS_PROFILE_SAVE_SUPER,
  payload,
});

export const businessProfileImageFileSuper = payload => ({
  type: BUSINESS_PROFILE_IMAGE_FILE_SUPER,
  payload,
});

export const handleRequestCloseBusinessProfile = () => ({
  type: HANDLE_REQUEST_CLOSE_BUSINESS_PROFILE
});

export const toggleDisabledBusiness = payload => ({
  type: TOGGLE_DISABLED_BUSINESS,
  payload
})

export const toggleDisabledBusinessProfile = payload => ({
  type: TOGGLE_DISABLED_BUSINESS_PROFILE,
  payload
})


// WEBPACK FOOTER //
// ./actions/BusinessSuperAdmin.js